import React, { useState, useEffect } from 'react';
import { FiGlobe, FiHelpCircle, FiSettings, FiExternalLink, FiFolder } from 'react-icons/fi';
import Swal from 'sweetalert2';

export default function GoogleDrivePage() {
  const [folderId, setFolderId] = useState(
    localStorage.getItem('google_drive_folder_id') || '12L9kRkK53x_d18D9DskXW9wR26YxW0Vp' // Demo placeholder ID
  );
  const [inputVal, setInputVal] = useState(folderId);

  const handleSave = (e) => {
    e.preventDefault();
    if (!inputVal.trim()) {
      Swal.fire('คำเตือน', 'กรุณากรอก Google Drive Folder ID', 'warning');
      return;
    }
    localStorage.setItem('google_drive_folder_id', inputVal.trim());
    setFolderId(inputVal.trim());
    Swal.fire('สำเร็จ', 'บันทึก ID โฟลเดอร์ Google Drive เรียบร้อยแล้ว', 'success');
  };

  return (
    <div className="space-y-6 pb-20 animate-fade-in text-gray-800 dark:text-gray-100 font-sans text-left h-[calc(100vh-125px)] flex flex-col">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 flex-shrink-0">
        <div>
          <h1 className="text-xl font-black text-gray-850 dark:text-white flex items-center gap-2">
            <FiGlobe className="text-blue-500" /> Google Drive คลังรูปหน้าเว็บ
          </h1>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            เชื่อมต่อและจัดการไฟล์รูปภาพสินค้า แคตาล็อก และภาพผลงานใน Google Drive ของคุณโดยตรงจากบนเว็บแอดมิน
          </p>
        </div>
        <a 
          href={`https://drive.google.com/drive/folders/${folderId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-bold py-2 px-3 rounded-lg shadow flex items-center gap-1 transition shrink-0"
        >
          <FiExternalLink size={12} /> เปิดในแอป Google Drive
        </a>
      </div>

      {/* Configuration Form */}
      <div className="bg-white dark:bg-[#131825] border border-gray-200 dark:border-[#1e2330] p-4 rounded-2xl shadow-sm flex-shrink-0 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <form onSubmit={handleSave} className="flex-1 flex flex-col md:flex-row items-stretch md:items-center gap-3">
          <div className="flex items-center gap-2">
            <FiFolder className="text-indigo-500 shrink-0" size={16} />
            <label className="text-xs font-bold text-gray-700 dark:text-gray-300 whitespace-nowrap">ID โฟลเดอร์ปัจจุบัน:</label>
          </div>
          <input 
            type="text"
            value={inputVal}
            onChange={(e) => setInputVal(e.target.value)}
            placeholder="กรอก Google Drive Folder ID (เช่น 12L9kRkK53x_d18D9DskXW9wR26YxW0Vp)"
            className="flex-1 p-2 bg-gray-50 dark:bg-[#1e2330]/40 border border-gray-200 dark:border-gray-800 text-xs rounded-lg outline-none focus:border-indigo-500 text-gray-800 dark:text-white"
          />
          <button 
            type="submit"
            className="bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-bold py-2 px-4 rounded-lg transition"
          >
            บันทึกการเชื่อมต่อ
          </button>
        </form>
        
        {/* Help tooltip */}
        <button
          onClick={() => Swal.fire({
            title: 'วิธีนำ Folder ID มาใส่',
            html: `<div class="text-left text-xs space-y-2 leading-relaxed">
              <p><strong>ขั้นตอนที่ 1:</strong> เปิดโฟลเดอร์ Google Drive ของคุณในเบราว์เซอร์ปกติ</p>
              <p><strong>ขั้นตอนที่ 2:</strong> คัดลอกรหัสอักขระยาวๆ ด้านหลังสุดของ URL ในช่องแอดเดรสบาร์</p>
              <p class="font-mono bg-gray-150 dark:bg-gray-800 p-1.5 rounded text-[10px]">เช่น drive.google.com/drive/folders/<strong>12L9kRkK53x...</strong></p>
              <p><strong>ขั้นตอนที่ 3:</strong> นำส่วนที่เป็นรหัสดังกล่าวมาวางลงในช่องด้านบนนี้แล้วกดบันทึก</p>
              <p class="text-amber-500"><em>*คำแนะนำ: อย่าลืมแชร์โฟลเดอร์ใน Google Drive ให้มีสิทธิ์เป็น "ทุกคนที่มีลิงก์มีสิทธิ์ดู" (Anyone with the link can view) เพื่อให้แสดงผลไฟล์ภาพได้สมบูรณ์ครับ</em></p>
            </div>`,
            icon: 'question',
            confirmButtonText: 'เข้าใจแล้ว'
          })}
          className="text-gray-400 hover:text-gray-300 flex items-center gap-1 text-xs shrink-0 self-center"
        >
          <FiHelpCircle size={14} /> วิธีตั้งค่าโฟลเดอร์
        </button>
      </div>

      {/* Google Drive Iframe Viewer Container */}
      <div className="flex-1 min-h-0 bg-white dark:bg-[#131825] border border-gray-200 dark:border-[#1e2330] rounded-2xl overflow-hidden shadow-sm relative">
        {folderId ? (
          <iframe 
            src={`https://drive.google.com/embeddedfolderview?id=${folderId}#grid`}
            style={{ width: '100%', height: '100%', border: 'none' }}
            title="Google Drive Embedded Folder View"
            allow="autoplay"
          ></iframe>
        ) : (
          <div className="absolute inset-0 flex flex-col justify-center items-center gap-2 text-gray-400">
            <FiFolder size={48} className="animate-pulse" />
            <p className="text-xs">กรุณากรอกและบันทึก ID โฟลเดอร์ Google Drive ด้านบนเพื่อเริ่มดูคลังรูปภาพ</p>
          </div>
        )}
      </div>
    </div>
  );
}
